<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div class="delivery-ach-content">
        <div class="delivery-ach-lt">
          <JssRichText :field="fields?.title" class="delivery-ach-title" tag="h2" />
          <JssRichText :field="fields?.subtitle" class="delivery-ach-subtitle" />
        </div>
        <AdaptiveMedia class="delivery-ach-ct" :field="fields?.media" />
        <div class="delivery-ach-rt">
          <Icon :svg="fields?.icon?.value?.svgCode" class="delivery-ach-rt-icon" />
          <JssRichText :field="fields?.desc" class="delivery-ach-rt-desc" />
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'DeliveryApproach',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'delivery-ach'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.delivery-ach {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &-lt {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &-title {
    font-weight: 700;
  }

  &-subtitle {
    font-size: 16px;
    line-height: 1.4;
  }

  &-rt {
    padding: 24px;
    background: #efeadf;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &-rt-icon {
    width: 40px;
    height: 40px;

    svg {
      width: 40px;
      height: 40px;
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-content {
      flex-direction: row;
      gap: 60px;
    }

    &-lt {
      flex: 7;
      padding-top: 58px;
    }

    &-ct {
      flex: 8;

      video {
        aspect-ratio: 394 / 498;
      }
    }

    &-rt {
      flex: 6;
      align-self: flex-end;
    }
  }
}
</style>
